<template>
  <div>
    <h2>Pending Reviews</h2>

    <v-data-table
      :headers="headers"
      :items="invitations"
      :items-per-page="10"
      class="elevation-1 mt-5"
    >
      <template v-slot:[`item.dateResponded`]="{ item }">
        <small>
          {{ item.dateResponded ? formatDate(item.dateResponded) : "-" }}
        </small>
      </template>
      <template v-slot:[`item.user.firstName`]="{ item }">
        {{ item.user.title }} {{ item.user.firstName }}
        {{ item.user.lastName }} <br />
        <small>({{ item.user.institution }})</small>
      </template>
      <template v-slot:[`item._id`]="{ item }">
        <v-btn
          small
          outlined
          color="green"
          class="my-1 mr-1"
          :to="`/reviews/pending/${item.manuscript._id}/${item._id}`"
        >
          Details / Review
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { formatDate } from "../../tools/format";

export default {
  data: () => ({
    loading: false,
    invitations: [],
    headers: [
      { text: "Invitation Accepted", value: "dateResponded" },
      {
        text: "Manuscript Title",
        align: "start",
        value: "manuscript.title",
      },
      { text: "Manuscript Type", value: "manuscript.type" },
      { text: "Actions", value: "_id", sortable: false },
    ],
  }),
  methods: {
    formatDate,
    fetchManuscriptsForReview() {
      this.loading = true;
      this.$axios
        .get("/reviews/pending")
        .then(({ data: response }) => {
          this.invitations = response;
        })
        .catch(() => {
          this.$bus.$emit("snackbar", {
            type: "error",
            message: "Could not retrieve accepted invitations",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.fetchManuscriptsForReview();
    this.$bus.$on("reviews.reload", this.fetchManuscriptsForReview);
  },
};
</script>